import React from 'react';

class ListItemThongKeXuLyDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    let Item = this.props.item || {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{Item.donVi ? Item.donVi.ten : (Item.capDonVi ? Item.capDonVi.ten : '')}</td>

        <td className='txt-center'>{Item.tongSoDonTiepNhanXLDTCD ? Item.tongSoDonTiepNhanXLDTCD : 0}</td>
        <td className='txt-center'>{Item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? Item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0}</td>
        <td className='txt-center'>{Item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? Item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0}</td>
        <td className='txt-center'>{Item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? Item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang :0}</td>
        <td className='txt-center'>{Item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? Item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : 0}</td>
        <td className='txt-center'>{Item.tongSoDonDuDieuKienThuLy ? Item.tongSoDonDuDieuKienThuLy : 0}</td>

        <td className='txt-center'>{Item.tongSoDonKhieuNaiLinhVucHanhChinh ? Item.tongSoDonKhieuNaiLinhVucHanhChinh : 0}</td>
        <td className='txt-center'>{Item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? Item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0}</td>
        <td className='txt-center'>{Item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan ? Item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan : 0}</td>
        <td className='txt-center'>{Item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC ? Item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC : 0}</td>
        <td className='txt-center'>{Item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac ? Item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac : 0}</td>

        <td className='txt-center'>{Item.tongSoDonKhieuNaiLinhVucTuPhap ? Item.tongSoDonKhieuNaiLinhVucTuPhap : 0}</td>
        <td className='txt-center'>{Item.tongSoDonKhieuNaiLinhVucVeDang ? Item.tongSoDonKhieuNaiLinhVucVeDang : 0}</td>

        <td className='txt-center'>{Item.tongSoDonLinhVucToCao ? Item.tongSoDonLinhVucToCao : 0}</td>
        <td className='txt-center'>{Item.tongSoDonToCaoLinhVucHanhChinh ? Item.tongSoDonToCaoLinhVucHanhChinh : 0}</td>
        <td className='txt-center'>{Item.tongSoDonToCaoLinhVucTuPhap ? Item.tongSoDonToCaoLinhVucTuPhap : 0}</td>
        <td className='txt-center'>{Item.tongSoDonToCaoLinhVucThamNhung ? Item.tongSoDonToCaoLinhVucThamNhung : 0}</td>
        <td className='txt-center'>{Item.tongSoDonToCaoLinhVucVeDang ? Item.tongSoDonToCaoLinhVucVeDang : 0}</td>
        <td className='txt-center'>{Item.tongSoDonToCaoLinhVucKhac ? Item.tongSoDonToCaoLinhVucKhac : 0}</td>

        <td className='txt-center'>{Item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap ? Item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap : 0}</td>
        <td className='txt-center'>{Item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap ? Item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap : 0}</td>
        <td className='txt-center'>{Item.tongSoDonTheoTQGQCuaCoQuanDang ? Item.tongSoDonTheoTQGQCuaCoQuanDang : 0}</td>

        <td className='txt-center'>{Item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet ? Item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet : 0}</td>
        <td className='txt-center'>{Item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet ? Item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet : 0}</td>

        <td className='txt-center'>{Item.tongSoDonXLDDonKienNghiPhanAnh ? Item.tongSoDonXLDDonKienNghiPhanAnh : 0}</td>

        <td className='txt-center'>{Item.tongSoDonXLDSoVanBanHuongDan ? Item.tongSoDonXLDSoVanBanHuongDan : 0}</td>
        <td className='txt-center'>{Item.tongSoDonChuyenCQCoThamQuyen ? Item.tongSoDonChuyenCQCoThamQuyen : 0}</td>
        <td className='txt-center'>{Item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet ? Item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet : 0}</td>

        <td className='txt-center'>{Item.tongSoDonThuocThamQuyenKhieuNai ? Item.tongSoDonThuocThamQuyenKhieuNai : 0}</td>
        <td className='txt-center'>{Item.tongSoDonThuocThamQuyenToCao ? Item.tongSoDonThuocThamQuyenToCao : 0}</td>

        <td className='ghi-chu'>{Item.ghiChu ? Item.ghiChu : ''}</td>
      </tr>
    );
  }
}

export default ListItemThongKeXuLyDon;


// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/datatable/ListItemThongKeXuLyDon.jsx